export default "__VITE_ASSET__Dj6UL1XS__"